import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { AppLoaderPage } from '@gokrew/ui/components/AppLoaderPage';
import { usePerformanceSummary } from '@/hooks/performance/usePerformanceSummary';

/**
 * Performance pages follow the company's module switch (performance spec
 * PF-21, A20): while it is off a bookmarked URL goes back to the dashboard.
 */
export function PerformanceGuard({ children }: { children: ReactNode }) {
  const { data, isPending, isError } = usePerformanceSummary();
  if (isPending) return <AppLoaderPage />;
  if (isError || !data?.data.enabled) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
